import React from 'react';

import Badge from '@atlaskit/badge/badge';

const BadgePrimaryInvertedExample = (): React.JSX.Element => {
	return <Badge appearance="primaryInverted">{5}</Badge>;
};

export default BadgePrimaryInvertedExample;
